export default __webpack_public_path__ + "static/media/bgmobile.d94d13f1.jpg";